<template>
    <div color="info" class="shadow-sm bg-slate-100 border-white border rounded-lg">
        <analytics-sidebar-title @reset="emit('reset')">
            <slot name="title"></slot>
        </analytics-sidebar-title>

        <div class="p-3"><slot></slot></div>
    </div>
</template>

<script lang="ts" setup>
import AnalyticsSidebarTitle from './AnalyticsSidebarTitle.vue';

const emit = defineEmits(['reset']);
</script>
